import { IconPropsType } from '..';

export const DoubleCheckIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="kb-core-icon">
      <g id="Vector">
        <path
          d="M17.7449 5.2629L10.388 12.6198L6.14504 8.37683L4.88998 9.63189L10.388 15.1299L19 6.5196L17.7449 5.2629Z"
          fill="#3CA347"
        />
        <path
          d="M13.9312 4.66663L9.12358 9.47419L10.379 10.7296L15.1866 5.92203L13.9312 4.66663Z"
          fill="#3CA347"
        />
        <path
          d="M2.25541 8.88406L1 10.1395L5.99038 15.1299L7.24579 13.8744L2.25541 8.88406Z"
          fill="#3CA347"
        />
      </g>
    </g>
  </svg>
);
